import React, { useContext } from 'react';
import { ModalContext } from 'App';
import RejectConfirmationModal from '../modals/RejectConfirmationModal';

const useRejectConfirmation = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  applicationStatus,
  isDelinquent,
  isRetirement,
  id
) => {
  const setModal = useContext(ModalContext);
  const isStatusAllowed = ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR PERMIT PROCESS'].indexOf(applicationStatus) > -1;

  const isApplicationStatusAllowedDelinquent =
    ['FOR LICENSE ASSESSMENT'].indexOf(applicationStatus) > -1;

  const isAllowedDelinquent =
    true &&
    isStatusAllowed &&
    isApplicationStatusAllowedDelinquent &&
    isStartAssessment;

  const isAllowed =
    true && isStatusAllowed && isApplicationStatusAllowed && isStartAssessment;
  const showComponent =
    isDelinquent === true || isRetirement === true
      ? isAllowedDelinquent
      : isAllowed;

  const onHandleClick = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <RejectConfirmationModal id={id} />,
      title: `Confirmation`,
      modalSize: 'modal-md',
    });
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-danger font-weight-bold"
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Reject
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useRejectConfirmation;
